/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { coreService } from 'network-utils';

export const getVideoTutorials = 'video-tutorials-data';
export const getVideoTutorial = 'video-tutorial-data';

export const useGetVideoTutorials = (token: string) => {
    return useQuery([getVideoTutorials, token], () => coreService.videoTutorialApi.getVideoTutorials(token), {
        enabled: !!token,
        keepPreviousData: true
    });
};

export const useGetVideoTutorial = (token: string, uuid?: string) => {
    return useQuery(
        [getVideoTutorial, uuid, token],
        () => coreService.videoTutorialApi.getVideoTutorial(token, String(uuid)),
        {
            enabled: !!uuid && !!token,
            keepPreviousData: true
        }
    );
};
